import React, { useEffect, useState } from 'react';

import { GalleryEntry } from '@shared/api-dto';
import { getGallery } from '../../api/endpoints';
import { quote } from '../room/shared/room-data-helpers';
import { Header } from '../header';
import { PosterWipe } from './poster-wipe';
import './gallery.css';

export const Gallery = () => {
  const [entries, setEntries] = useState<GalleryEntry[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const result = await getGallery();
        if (!cancelled) {
          setEntries(result.entries);
        }
      } catch (e: any) {
        if (!cancelled) {
          setError(e);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Header />
      <div className='headerAccent'></div>
      <div className='gallery'>
        <header className='galleryIntro'>
          <h1>Gallery</h1>
          <p className='muted'>
            Sketches and the movie posters they became.
          </p>
        </header>
        {error && (
          <p className='red galleryStatus'>{'' + error}</p>
        )}
        {entries === null && !error && (
          <p className='muted galleryStatus'>Loading…</p>
        )}
        {entries && entries.length === 0 && (
          <p className='muted galleryStatus'>
            No posters yet. Play a Drawn Together round to fill the gallery.
          </p>
        )}
        {entries && entries.length > 0 && (
          <div className='galleryGrid'>
            {entries.map((entry, index) => (
              <article
                className='galleryCard'
                key={`${entry.posterUrl}-${entry.service}-${index}`}
              >
                <h2 className='galleryPrompt'>{entry.promptText}</h2>
                <p className='galleryResponse'>{quote(entry.responseText)}</p>
                <PosterWipe
                  sketchUrl={entry.sketchUrl}
                  posterUrl={entry.posterUrl}
                />
                <p className='galleryService muted'>{entry.description}</p>
              </article>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
